<div class="h-100 d-flex justify-content-center align-items-center">
    <div class="text-center default-icon-color">
        <div>
            <i class="fas fa-info-circle fa-7x"></i>
            <div class="no-records-message">{{ 'notAuthorized.title' | translation | async }}</div>
            <div class="no-records-message-detail">{{ 'notAuthorized.message' | translation | async }}</div>
        </div>
    </div>
</div>
